import { ReactElement } from 'react'
import Layout from '../../../components/layout'
import ShopOrderDetails from '../../../components/Shops/Orders/details'

const ShopOrderDetailsPage = (): ReactElement => {
  return (
    <Layout >
      <ShopOrderDetails />
    </Layout>
  )
}

export default ShopOrderDetailsPage
